// extracted by mini-css-extract-plugin
export default {"contextMenu":"contextMenu__T9Fu5r","captionEndItem":"captionEndItem__hjDeR_","formatTextItem":"formatTextItem__rqOqja","divider":"divider__MS3wmy"};